import { APP_LINKS, SERVICE_CATEGORIES } from "../constants/site";
import { Seo } from "../components/site/Seo";
import { Reveal, SectionHead } from "../components/site/Shared";
import { Icon } from "../components/site/Icon";

const STEPS = [
  {
    icon: "Wrench",
    title: "Pick a category",
    text: "Choose from the service categories Indian homes use most — plumbing, electrical, AC repair, RO service and more.",
  },
  {
    icon: "CalendarCheck",
    title: "Book or send a request",
    text: "Book an approved provider directly, or send a request that matching approved, subscribed pros in your city can respond to.",
  },
  {
    icon: "Lock",
    title: "You stay in control",
    text: "Providers see only the summary needed for your request. Your name, exact address and documents stay private until you choose to share.",
  },
];

export default function Services() {
  return (
    <>
      <Seo
        title="Home Services — Plumbing, Electrical, Cleaning & More"
        description="Book approved home-service professionals through HomeAligns: plumbing, electrical, cleaning, painting, carpentry, pest control, AC, refrigerator and washing machine repair, RO and geyser services."
        path="/home-services"
      />
      <section className="container-site py-20 lg:py-24">
        <SectionHead
          level={1}
          eyebrow="Home services"
          title="Trusted help for every corner of your home."
          sub="HomeAligns connects you with independent, approved service professionals. Availability depends on approved providers in your city — check the app for coverage where you live."
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {SERVICE_CATEGORIES.map((c, i) => (
            <Reveal key={c.name} delay={(i % 4) + 1} className="card-site p-6">
              <span className="icon-tile">
                <Icon name={c.icon} className="h-5 w-5" />
              </span>
              <p className="mt-4 text-sm font-bold text-ink">{c.name}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="container-site">
          <SectionHead
            eyebrow="How booking works"
            title="Three steps, zero phone-tag."
          />
          <div className="grid gap-6 md:grid-cols-3">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={i + 1} className="card-site p-8">
                <span className="icon-tile">
                  <Icon name={s.icon} className="h-5 w-5" />
                </span>
                <h3 className="mt-5 text-base font-bold text-ink">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink/60">{s.text}</p>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12 flex flex-wrap items-center gap-4">
            <a href={APP_LINKS.getStarted} data-testid="services-get-started-btn" className="btn-primary">
              Book a service <Icon name="ArrowRight" className="h-4 w-4" />
            </a>
            <a href={APP_LINKS.registerVendor} data-testid="services-vendor-btn" className="btn-secondary">
              Join as a Service Professional
            </a>
          </Reveal>
          <Reveal className="mt-8 rounded-2xl border border-teal-deep/10 bg-mist/60 p-5">
            <p className="text-xs leading-relaxed text-ink/55">
              HomeAligns does not employ service providers and is not a party to the service you
              agree with a provider. Bookings and responses are not guaranteed — providers decide
              whether to respond, and you choose whether to proceed.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
